import { useQuery } from '@tanstack/react-query'
import { companiesKey } from './keys'
import { getCompanies } from 'api/company'
import { useAuthContext } from 'components/auth'

// DEPRECATED: Use useAuthContext() instead
export function useCompanies({
  excludeNonGroupCompanies = false,
}: {
  excludeNonGroupCompanies?: boolean
}) {
  // TODO: this hook should not be mounted when user is not authenticated
  const { isAuthenticated } = useAuthContext()
  return useQuery({
    queryKey: companiesKey,
    queryFn: () => getCompanies(excludeNonGroupCompanies),
    gcTime: Infinity, // the only time this would change is if current company changes
    staleTime: Infinity,
    enabled: isAuthenticated,
  })
}
